import EleFormVideoUploader from './EleFormVideoUploader'

export default EleFormVideoUploader
